import "../settings.scss";

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import React, { useState } from "react";

import Form from "reactstrap/lib/Form";
import Loading from "../../loader/loader";
import NkHeader from "./../../../common/nkheader";
import { changeUserPassword } from "../../users/utils";

import {
  notificationStrings,
  openNotificationWithIcon,
} from "../../../common/notification-message/notification";
const ChangePassword = ({
  searchBy,
  setSearchByValue,
  setSearchBy,
  searchByValuePlaceholder,
  searchByValue,

  handleFIlter,
}) => {
  const [oldpassword, setOldPassword] = useState("");
  const [newpassword, setNewPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const [updateLoading, setupdateLoading] = useState(false);
  const [flag, setFlag] = useState(false);
  const handleNewPassword = (e) => {
    setNewPassword(e.target.value);
  };
  const handleConfirmPassword = (e) => {
    setConfirmPassword(e.target.value);
    console.log(e.target.value);
    if (e.target.value === newpassword || e.target.value === "") {
      setFlag(false);
    } else {
      setFlag(true);
    }
  };

  const handleSubmit = (e, vals) => {
    e.preventDefault();
    console.log("EEEE ::", newpassword);
    console.log("CONF ::", confirmpassword);
    passwordUpdate();
  };

  const passwordUpdate = () => {
    // request.size = sizeShow || 10;
    const request = {
      newPassword: newpassword,
      oldPassword: oldpassword,
    };
    setupdateLoading(true);
    changeUserPassword(request)
      .then((res) => {
        openNotificationWithIcon(
          notificationStrings.success,
          "Password changed successfully"
        );
        setupdateLoading(false);
        console.log("Logout Clicked");
        localStorage.clear();
        sessionStorage.clear();
      })
      .catch((err) => {
        setupdateLoading(false);
      });
  };
  console.log("flag", flag);
  return (
    <>
      <Container fluid>
        <NkHeader title="Change Password" />
        <Card>
          <CardBody>
            <Row>
              <Col lg="4" className="form-input-padding">
                <Form onSubmit={handleSubmit}>
                  <FormGroup className="change-pass-input">
                    <label
                      className="form-control-label"
                      htmlFor="example3cols2Input"
                    >
                      Old password*
                    </label>
                    <Input
                      id="oldPassword"
                      placeholder={"Old password"}
                      type="text"
                      name="oldpassword"
                      value={oldpassword}
                      onChange={(e) => setOldPassword(e.target.value)}
                    />
                  </FormGroup>
                  <FormGroup className="change-pass-input">
                    <label
                      className="form-control-label change-pass-pass-text"
                      htmlFor="example3cols2Input"
                    >
                      Enter New Password*
                    </label>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        padding: "5px 0px",
                      }}
                    >
                      <text style={{ fontSize: "10px", color: "gray" }}>
                        Must have atleast 6 characters
                      </text>
                    </div>
                    <Input
                      id="example3cols2Input"
                      type="text"
                      name="newpassword"
                      placeholder="Enter new password.."
                      value={newpassword}
                      onChange={handleNewPassword}
                    />
                  </FormGroup>

                  <FormGroup className="change-pass-input">
                    <label
                      className="form-control-label"
                      htmlFor="example3cols2Input"
                    >
                      Confirm New Password*
                    </label>

                    <Input
                      id="example3cols2Input"
                      type="text"
                      placeholder="confirm new password.."
                      name="confirmpassword"
                      value={confirmpassword}
                      onChange={handleConfirmPassword}
                    />
                    {flag ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          padding: "5px 0px",
                        }}
                      >
                        <text style={{ fontSize: "10px", color: "red" }}>
                          Password Mismatch
                        </text>
                      </div>
                    ) : (
                      <div style={{ marginTop: "10px" }}></div>
                    )}
                  </FormGroup>

                  <button
                    className="btn btn-primary mt-2 change-pass-btn"
                    type="submit"
                    disabled={
                      !newpassword ||
                      newpassword.length < 6 ||
                      confirmpassword.length < 6 ||
                      !(newpassword === confirmpassword) ||
                      updateLoading
                    }
                    style={{ width: "150px" }}
                  >
                    {updateLoading ? (
                      <Loading color="white" width="15px" height="15px" />
                    ) : (
                      "Reset password"
                    )}
                  </button>
                </Form>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default ChangePassword;
